<template>

    <el-row>
      <el-col :span="24">

        <pie-chart :data="chart"
          :donut="false"
          thousands=","
          suffix="%"
          :colors="colours"
          legend="left" />

      </el-col>
  </el-row>

</template>

<script>

import NumberMixins from '@/mixins/NumberMixins'

import {chartColors} from '@/components/Data'

export default {
  mixins: [NumberMixins],


  props: {

    sharerData: {
      type: Array,
      required: true
    }

  },



  watch: {
    sharerData: function (value) {
      this.processData(value)
    }
  },


  methods: {

    processData (data) {
      this.sharers = []
      this.chart = []

      this.sharers = data

      if (this.sharers && this.sharers.length > 0) {

        for (var i = 0; i < this.sharers.length; i++) {
          this.chart.push([(this.sharers[i].shortName ? this.sharers[i].shortName : this.sharers[i].name), Number(Number(this.sharers[i].percent).toFixed(2))])

          if (this.sharers[i].colourCode) {
            this.colours[i] = this.sharers[i].colourCode
          }
        }
      }
    }

  },



  data () {

    return {
      sharers: null,
      chart: null,
      colours: chartColors
    }

  },

  created () {
    this.processData(this.sharerData)
  }
}
</script>



// WEBPACK FOOTER //
// SharersChart.vue?b70633a0